import { handleNoInteractiveContentError } from '../../applications/common/handle-no-interactive-content-error';
import type { EditorQuestionWithSlide } from '../../compatibility-overrides/editor-types';
import type {
  CompatibilityQuestionWithSlide,
  CompatibilitySlide,
} from '../../compatibility-types';
import { getOrSetCache, type WithCache } from '../../utils/get-or-set-cache';
import { correctAreaToQuestionCorrectArea } from '../converters/interactive-content';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionPinOnImageProperty = (
  target: CompatibilitySlide<'pin-on-image'>,
  prop: keyof EditorQuestionWithSlide,
) => {
  const interactiveContents = target.interactiveContents?.[0];
  const staticContents = target.staticContent;

  if (prop === 'question_styled') {
    return staticContents.styledTitle ?? {};
  }

  if (interactiveContents) {
    switch (
      prop as keyof Omit<EditorQuestionWithSlide, CommonQuestionProperty>
    ) {
      case 'correct_area':
        const correctArea = correctAreaToQuestionCorrectArea(
          interactiveContents.correctArea,
        );

        const cacheKey = JSON.stringify(correctArea);
        return getOrSetCache(
          target as WithCache<CompatibilityQuestionWithSlide>,
          'correct_area',
          cacheKey,
          correctArea,
        );

      default:
        return undefined;
    }
  }

  return handleNoInteractiveContentError(target, prop);
};
